<template>
  <ShopLogin :config="config" />
</template>

<script>
import ShopLogin from "../../components/ShopLogin/ShopLogin.vue";

export default {
  name: "app",
  components: {
    ShopLogin
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config)
    };
  }
};
</script>
